/**
 * Shared debounce state for the O'Neil sell-signal marker hover tooltip.
 * Kept as a separate module (rather than reusing eventTooltipState.ts) so the
 * corporate-event tooltip and this one can be hovered/cleared independently —
 * registerTooltipClearFn only supports a single registered clear callback.
 * ChartContainer schedules the clear; WilliamOneilSellTooltip cancels it on
 * mouseEnter.
 */

let _clearTimer: ReturnType<typeof setTimeout> | null = null;
let _clearFn: (() => void) | null = null;

export function registerSellTooltipClearFn(fn: () => void): void {
  _clearFn = fn;
}

export function scheduleSellTooltipClear(delayMs = 180): void {
  cancelSellTooltipClear();
  _clearTimer = setTimeout(() => {
    _clearFn?.();
    _clearTimer = null;
  }, delayMs);
}

export function cancelSellTooltipClear(): void {
  if (_clearTimer != null) {
    clearTimeout(_clearTimer);
    _clearTimer = null;
  }
}
